import { useMutation } from '@zg-rentals/react-query5';
import { useDispatch } from 'react-redux';

import type { IAPIErrorResponse } from '../../interfaces';
import { RENTAL_MANAGER_API_V1_PREFIX } from '../../constants/RouteConstants';
import StringConstants from '../../constants/StringConstants';
import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../useRequestConfig';

type QueryOptionsArgs = {
  onSuccess: () => void;
  onError: (err: IAPIErrorResponse) => void;
};

const useUpdateUnitVideoLink = (propertyId: string, queryOptions?: QueryOptionsArgs) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig(StringConstants.POST);

  const queryFn = ({ feedModelId, videoUrl }: { feedModelId: string; videoUrl: string }) =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V1_PREFIX}/users/properties/floorPlans/units/videoUrl`,
      requestConfig,
      config: { data: { listingAlias: propertyId, feedModelId, videoUrl } },
    });

  return useMutation({
    mutationFn: ({ feedModelId, videoUrl }: { feedModelId: string; videoUrl: string }) =>
      queryFn({ feedModelId, videoUrl }),
    ...queryOptions,
  });
};

export { useUpdateUnitVideoLink };
